
    $(function () {
        $(".faq-wrapper article").each(function () {
            $(this).find("div:first .que").addClass("rotate");
        });

        $(".tabs-content:first").show();

        

        //get first tab width

        var firstTab = $("#tabs li:first-child a").width();
        $(".activeTab").width(firstTab);

        $("#tabs li a").click(function () {
            var get_attr = $(this).attr("id");

            //get tab width

            var activeTab = $(this).width();
            var activeTab_pos = $(this).position();

            $(".activeTab").width(activeTab);

            $(".activeTab").css({ transform: "translateX(" + activeTab_pos.left + "px)" });

            $(".tabs-content").hide();

            $("#" + get_attr + "-Wrapper").show();

            return false;
        });

        $(".faq-wrapper article").hide();
      $(".roman-shades__before-going__tab-content .faq-wrapper article").show();

  
      $(".faq-wrapper article:first").show();
        $("#inside-the-frame-area").show();
      

        $("#tag-quetions li:first").addClass("tag-active");

        $("#tag-quetions li").click(function () {
            var current_tag = $(this).attr("id");
            $("#tag-quetions li").removeClass("tag-active");

            $(this).addClass("tag-active");

            $(".faq-wrapper article").hide();
          $(".roman-shades__before-going__tab-content .faq-wrapper article").show();
            $(".faq-wrapper article#" + current_tag + "-area").show();
        });

        $("#open-pop-up").click(function () {
            $("#popUp-Wrapper").addClass("show");

            return false;
        });

        $("#close").click(function () {
            $("#popUp-Wrapper").removeClass("show");
            return false;
        });

        $(".que:first").addClass("rotate");
        $(".que").click(function () {
            $(this).next().slideToggle();

            //   $('.que').removeClass('rotate');

            $(this).toggleClass("rotate");
        });
    });
